import * as React from 'react';

import { observer } from 'mobx-react';

import { Field, FormInput, FormStore } from '@estee/elc-form';
import { IFormValues } from '@estee/elc-form/typings/views/Form';

import { textInputFieldClasses } from '~utils/Classes';
import { FieldValidations } from '~utils/FieldValidations';

export interface INumberInputProps {
    inputLabel: string;
    name: string;
    fieldValidations: FieldValidations;
    formStore: FormStore<IFormValues>;
    disabled?: boolean;
    placeholder?: string;
}

export const NumberInput = observer((props: INumberInputProps) => {
    const { inputLabel, name, disabled, fieldValidations, placeholder = '' } = props;
    const { isRequired, maxLength, validations } = fieldValidations || {};

    return (
        <Field
            name={name}
            inputType="tel"
            inputLabel={inputLabel}
            customClassName={textInputFieldClasses(name)}
            isRequired={isRequired}
            disabled={disabled}
            maxLength={maxLength}
            dataTestId={`form_${name}`}
            component={FormInput}
            validations={validations}
            onInputBlur={(event: React.FocusEvent) =>
                ((event.target as HTMLInputElement).placeholder = '')
            }
            onInputFocus={(event: React.FocusEvent) =>
                ((event.target as HTMLInputElement).placeholder = placeholder)
            }
            onInput={(event: React.FormEvent) =>
                ((event.target as HTMLInputElement).value = (event.target as HTMLInputElement).value
                    .replace(/[^0-9.]/g, '')
                    .replace(/(\..*)\./g, '$1'))
            }
        />
    );
});

export const withPlaceholder = (placeholder: string) => {
    return class extends React.Component {
        render() {
            return <NumberInput placeholder={placeholder} {...(this.props as INumberInputProps)} />;
        }
    };
};
